import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; // Importa o ToastContainer
import 'react-toastify/dist/ReactToastify.css';
import Home from './pages/home';
import Login from './components/Admin/Login';
import AdminDashboard from './components/Admin/AdminDashboard';
import InserirLink from './components/Admin/InserirLink';
import EditarLink from './components/Admin/EditarLink';
import ExcluirLink from './components/Admin/ExcluirLink';
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

const App = () => {
  return (
    <Router>
      <ToastContainer position="bottom-center" autoClose={3000} /> {/* Adiciona o ToastContainer */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Login />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/inserir"
          element={
            <ProtectedRoute>
              <InserirLink />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/editar/"
          element={
            <ProtectedRoute>
              <EditarLink />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/excluir/"
          element={
            <ProtectedRoute>
              <ExcluirLink />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
